import { render, staticRenderFns } from "./item.vue?vue&type=template&id=6c71a9a0&scoped=true"
import script from "./item.vue?vue&type=script&setup=true&lang=js"
export * from "./item.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item.vue?vue&type=style&index=0&id=6c71a9a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71a9a0",
  null
  
)

export default component.exports